<template>
  <div class="content">
    <!-- Nagłówek: Filtry (widoczny tylko jeśli NIE jest tryb wyniku) -->
    <!-- <h2
      v-if="!isResult"
      data-bs-toggle="collapse"
      :href="`#current-filters`"
      role="button"
      aria-expanded="true"
      :aria-controls="`current-filters`"
      class="margin-0"
    >
    {{ t('filters').toUpperCase() }}
    </h2> -->
    <!-- Przyciski nawigacji krokami -->
    <div class="ds-toolbar actions">
      <!-- WSTECZ przy lewej krawędzi paska, DALEJ/ZASTOSUJ przy prawej —
           spójnie z kreatorami w bieżącym pomiarze i archiwum. -->
      <button class="ds-btn ds-btn--secondary btn-prev" v-if="step > 1" @click="previousStep()">
        <span class="ds-btn__arrow" aria-hidden="true">&#8592;</span>
        <span>{{ t('back2').toUpperCase() }}</span>
      </button>

      <label class="ds-switch" for="statistics-location-view-toggle" v-if="step === 1 && !isResult">
        <span class="ds-switch__label">{{ t('map').toUpperCase() }}</span>
        <input id="statistics-location-view-toggle" type="checkbox" v-model="useMapLocationList" />
        <span class="ds-switch__track"></span>
      </label>

      <div class="ds-toolbar__spacer"></div>

      <!-- Wskaźnik postępu kreatora statystyk (3 kroki) -->
      <div class="ds-stepper" v-if="!isResult">
        <span class="ds-stepper__label">
          {{ t('step-indicator', { current: step, total: 3 }) }}
        </span>
        <span class="ds-stepper__dots" aria-hidden="true">
          <span
            class="ds-stepper__dot"
            :class="{ 'is-active': step === n }"
            v-for="n in 3"
            :key="n"
          ></span>
        </span>
      </div>

      <div class="ds-toolbar__spacer"></div>

      <button class="ds-btn ds-btn--primary btn-next" v-if="step < 4 && !isResult" @click="nextStep()">
        {{ step === 3 ? t('apply').toUpperCase() : t('next').toUpperCase() }}
        <span class="ds-btn__arrow" aria-hidden="true">&#8594;</span>
      </button>
    </div>

    <!-- Sekcja filtrów: chowana/rozwijana collapse (Bootstrap/Manual) -->
    <div
      class="collapse"
      :class="hideFilters ? '' : 'show'"
      :id="`statistics-filters`"
    >
      <!-- Krok 1: wybór lokalizacji, daty, rozdzielczości -->
      <div v-if="step == 1">
        <div class="step-content step1">
          <preselect-tabs :store="filtersStore" />
          <!-- Filtry są nieaktywne, dopóki nie wybrano zestawu (zakładki) wyżej:
               to on ustawia zakres dat, rozdzielczość i blokady pól, więc
               grzebanie w nich przed wyborem i tak zostałoby nadpisane.
               `inert` (nie tylko `pointer-events`) wyłącza też fokus z klawiatury
               i wyjmuje panele z drzewa dostępności. -->
          <div
            class="step1__grid"
            :class="{ 'step1__grid--disabled': !hasPreselectTab }"
            :inert="hasPreselectTab ? null : true"
          >
            <component :is="locationListComponent" :store="filtersStore" />
            <date-range
              :store="filtersStore"
              :dateTimeStart="filtersStore.filters.dateTimeStart"
              :dateTimeEnd="filtersStore.filters.dateTimeEnd"
              :disabled="filtersStore"
            />
            <resolution-filter :store="filtersStore" />
          </div>
        </div>
      </div>
      <!-- Krok 2: rodzaje naruszeń, kategorie pojazdów, pasy -->
      <div class="step-content step2" v-else-if="step == 2 && !shouldHideLocation">
        <violation-list :store="filtersStore" />
        <vehicle-categories :store="filtersStore" :step="step" />
        <lane-numbers :store="filtersStore" :step="step" />
      </div>
      <!-- Krok 3: agregacje/statystyka -->
      <div class="step-content step3" v-else-if="step == 3">
        <group-by-filter :store="filtersStore" />
        <graph-type-filter :store="filtersStore" />
      </div>
    </div>

    <!-- Widok wyniku (raport statystyk) -->
    <div v-if="isResult" class="content">
      <spinner-element :loading="loading" />
      <div
        v-for="(statsDataItem, index) in statData"
        :key="statsDataItem"
        id="statsData"
      >
        <!-- Przyciski powrotu i pobrania -->
        <div class="ds-toolbar actions">
          <button class="ds-btn ds-btn--secondary btn-prev" @click="clear()">
            <span class="ds-btn__arrow" aria-hidden="true">&#8592;</span>
            <span>{{ t('back2').toUpperCase() }}</span>
          </button>
          <div class="ds-toolbar__spacer"></div>
          <button class="ds-btn button-download" :disabled="isDownloading" @click="retrieveZip()">
            <span>{{ t('download').toUpperCase() }}</span>
          </button>
        </div>
        <!-- Nazwa lokalizacji -->
        <h4 class="center-aligned">
          {{ statsDataItem.location.shortName }}
        </h4>
        <!-- Obrazek/statystyka (base64 img) -->
        <div class="center-aligned">
          <img v-bind:src="statImage[index]" class="img-fluid fitted-image" />
        </div>
        <div class="stats-data-wrapper">
          <!-- Tabela wynikowa (dane statystyczne) -->
          <table class="stats-data table table-striped">
            <thead class="thead-light">
              <tr>
                <th>{{ statsDataItem.labelPeriods }}</th>
                <th v-for="objectObj in statsDataItem.groups" :key="objectObj">
                  {{ objectObj.labelSeriesValue }}
                </th>
                <th>{{ t('sum') }}</th>
              </tr>
            </thead>
            <tbody v-if="statsDataItem.periods">
              <tr
                v-for="(period, index) in statsDataItem.periods"
                :key="period"
              >
                <td>{{ period.label }}</td>
                <th v-for="groupObj in statsDataItem.groups" :key="groupObj">
                  {{ groupObj.series[index].value }}
                </th>
                <td>{{ period.summary }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Ponowny przycisk powrotu -->
        <!-- <div class="d-flex justify-content-between actions">
          <button class="btn-prev" @click="clear()">
            <span>{{ t('back2').toUpperCase() }}</span>
          </button>
        </div> -->
        <hr/>
      </div>
    </div>
  </div>
</template>

<script>
// Importy zależności – Pinia store, serwis API, podkomponenty filtrów, spinnera itd.
import { useStatisticFiltersStore } from "../stores/statisticFilters";
import Statistics from "../services/Statistics";
import LocationList from "./filters/LocationList.vue";
import LocationList2 from "./filters/LocationList2.vue";
import DateRange from "./filters/DateRange.vue";
import LaneNumbers from "./filters/LaneNumbers.vue";
import VehicleCategories from "./filters/VehicleCategories.vue";
import ViolationList from "./filters/ViolationList.vue";
import PreselectTabs from "./statistics/PreselectTabs.vue";
import ResolutionFilter from "./statistics/ResolutionFilter.vue";
import moment from "moment";
import SpinnerElement from "./SpinnerElement.vue";
import GroupByFilter from "./statistics/GroupByFilter.vue";
import GraphTypeFilter from "./statistics/GraphTypeFilter.vue";
import { computed } from "vue";
import { isSG } from "@/config/appVersion";

// Ustaw język moment.js na polski
moment.locale("pl");

export default {
  // Podpięcie wszystkich podkomponentów używanych w szablonie
  components: {
    LocationList,
    LocationList2,
    DateRange,
    LaneNumbers,
    VehicleCategories,
    ViolationList,
    PreselectTabs,
    ResolutionFilter,
    SpinnerElement,
    GroupByFilter,
    GraphTypeFilter,
  },
  name: "StatisticsData",
  props: ["step", "isResult"], // Otrzymuje obecny krok procesu oraz czy jesteśmy w trybie "wynik"
  setup() {
    // Użycie Pinia store dla filtrów statystyk (dostępny jako filtersStore)
    const filtersStore = useStatisticFiltersStore();
    const shouldHideLocation = computed(() => isSG);

    return { filtersStore, shouldHideLocation, isSG };
  },
  data() {
    return {
      error: null,
      isDownloading: false, // Czy trwa pobieranie ZIP
      hideFilters: false,   // Czy ukryć UI z filtrami (tryb wyniku)
      moment: moment,       // Instancja moment.js do użycia w szablonie
      statGraph: [],        // Dane wykresów/statystyk dla lokalizacji
      statImage: [],        // Obrazki base64 (jako string do <img src=...>)
      useMapLocationList: false,
      filtersChangeTimer: null, // Timer sklejający wieloetapowe zmiany filtrów w jedno pobranie
    };
  },
  created() {
    // Zmiana filtrów w panelu bocznym (ikona kosza, odznaczenie lokalizacji) musi przeładować
    // wykres i tabelę. Wcześniej reagowaliśmy tylko na liczbę kluczy w `filters`, więc kosz przy
    // zakresie dat (podstawia wartości domyślne, nie usuwa kluczy) nie robił nic, a pozostałe
    // kosze wyrzucały użytkownika do kreatora, zamiast pokazać wynik dla nowych filtrów.
    this.$watch(
      () => this.filtersStore.filters,
      () => {
        this.onFiltersChanged();
      },
      { deep: true }
    );
  },
  beforeUnmount() {
    if (this.filtersChangeTimer) {
      clearTimeout(this.filtersChangeTimer);
      this.filtersChangeTimer = null;
    }
  },
  watch: {
    isResult: function (newVal) {
      if (newVal === true) {
        this.retrieveGraph();
      }
    },
  },
  computed: {
    // Getter do wyciągnięcia tabeli danych do template
    statData() {
      return this.statGraph;
    },
    locationListComponent() {
      return this.useMapLocationList ? "LocationList2" : "LocationList";
    },
    // Czy wybrano zestaw predefiniowany (zakładkę) — `preselectActiveTab`
    // startuje jako pusty string, więc do pierwszego kliknięcia jest `false`.
    hasPreselectTab() {
      return !!this.filtersStore.preselectActiveTab;
    },
  },
  methods: {
    // Pobierz z backendu dane dla wykresu i statystyk
    retrieveGraph() {
      this.loading = true;
      this.hideFilters = true; // Schowaj filtry, pokaż spinner i potem wynik

      // Wyczyść poprzedni wynik – inaczej gdy nowe zapytanie zwróci mniej lokalizacji
      // niż poprzednie, stare wykresy zostają na końcu tablicy i renderują się poniżej.
      this.statGraph = [];
      this.statImage = [];

      // Wołamy serwis, dostajemy np. obiekty { location, periods, groups, graph: base64 }
      Statistics.getGraph()
        .then((data) => {
          this.loading = false;
          for (const graphs in data) {
            const statGraphData = data[graphs];
            // Dane statystyki (z backendu) pod dany indeks
            this.statGraph[graphs] = statGraphData;
            // Rysunek (img src) - zakładamy, że backend zwraca base64 jpeg!
            this.statImage[graphs] = "data:image/jpeg;base64," + statGraphData.graph;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.filtersStore.setErrors(error);
        });
    },

    // Pobieranie raportu ZIP z backendu (np. plik Excela/PDF ze statystykami)
    retrieveZip() {
      this.isDownloading = true;
      Statistics.getZip()
        .then((data) => {
          Statistics.fetch(data.link)
            .then((response) => {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(response);
              link.download = "statistics";
              link.click();
              this.isDownloading = false;
              URL.revokeObjectURL(link.href);
            })
            .catch(console.error);
        })
        .catch((error) => {
          this.loading = false;
          this.filtersStore.setErrors(error);
        });
    },

    // Obsługa nawigacji między krokami
    nextStep() {
      // Jeżeli SG (shouldHideLocation) i jesteśmy na kroku 1 → pomiń 2 i leć na 3
      if (this.step === 1 && this.shouldHideLocation) {
        this.$emit('nextStep'); // 1 -> 2
        this.$emit('nextStep'); // 2 -> 3
      } else {
        this.$emit('nextStep');
      }
    },
    previousStep() {
      // Jeżeli SG i jesteśmy na kroku 3 → cofnij o dwa (na 1)
      if (this.step === 3 && this.shouldHideLocation) {
        this.$emit('previousStep'); // 3 -> 2
        this.$emit('previousStep'); // 2 -> 1
      } else {
        this.$emit('previousStep');
      }
    },

    // Wyczyść dane/statystyki i wróć do widoku filtrów
    clear() {
      this.$emit("clear");
      this.hideFilters = false;
    },

    // Helper do obsługi kliknięcia w nagłówek filtrów (np. rozwiń/zwiń)
    clickFilters(event) {
      if (event.target.className !== "collapsed") {
        this.hideFilters = false;
      }
    },

    // Czy filtry mają wszystkie parametry wymagane do pobrania statystyki
    // (ten sam zestaw co `checkRequireData1` w store, tylko bez komunikatu o błędzie).
    hasRequiredFilters() {
      const f = this.filtersStore.filters;
      return (
        !!f.dateTimeStart &&
        !!f.dateTimeEnd &&
        !!f.locations?.length &&
        !!f.statResolutionUnit &&
        !!f.statResolutionValue
      );
    },

    // Reakcja na zmianę filtrów w trybie wyniku
    onFiltersChanged() {
      if (!this.isResult) {
        return;
      }

      // Usunięcie filtra bywa wieloetapowe (kilka kluczy naraz, a kontrolki w kreatorze
      // dosynchronizowują się w kolejnym tiku), więc zmiany z jednej interakcji sklejamy
      // w jedno pobranie wykresu.
      if (this.filtersChangeTimer) {
        clearTimeout(this.filtersChangeTimer);
      }

      this.filtersChangeTimer = setTimeout(() => {
        this.filtersChangeTimer = null;

        if (!this.isResult) {
          return;
        }

        // Bez wymaganych parametrów (lokalizacje, zakres dat, rozdzielczość) nie ma czego
        // pokazać — wracamy do kreatora filtrów.
        if (!this.hasRequiredFilters()) {
          this.clear();
          return;
        }

        this.retrieveGraph();
      }, 200);
    },
  },
};
</script>

<style scoped>
/* =============================================================================
   Statystyki — kreator (kroki 1-3) + widok raportu (wykres + tabela).
   Panele, kontrolki i przyciski pochodzą z design-system.css.
   ========================================================================== */

.content,
.step-content {
  width: 100%;
  min-height: 485px;
}

/* --- pasek akcji ---------------------------------------------------------- */

.actions {
  background: var(--surface-primary);
  flex-wrap: wrap;
}

/* --- kroki kreatora ------------------------------------------------------- */

.step-content {
  display: grid;
  gap: var(--spacing-md);
  align-items: start;
  /* Wiersze trzymają swoją naturalną wysokość. Bez tego (domyślne
     `align-content: stretch`) nadwyżka z `min-height: 485px` rozdzielała się
     między wiersze i między zakładkami a panelami zostawała ~100 px dziury. */
  align-content: start;
  padding: var(--spacing-md);
  background: var(--surface-secondary);
}

/* Krok 1: zakładki preselekcji nad siatką lokalizacje | daty | rozdzielczość */
.step1 {
  grid-template-columns: minmax(0, 1fr);
}

.step1__grid {
  display: grid;
  grid-template-columns:
    minmax(340px, 1.5fr)
    minmax(260px, 1fr)
    minmax(220px, 0.9fr);
  gap: var(--spacing-lg);
  align-items: start;
}

/* Stan przed wyborem zestawu: panele wyszarzone i nieklikalne.
   `pointer-events` zostaje jako zabezpieczenie dla przeglądarek bez `inert`. */
.step1__grid--disabled {
  opacity: 0.55;
  pointer-events: none;
}
/* Krok 2: przekroczenia | kategorie | pasy */
.step2 {
  grid-template-columns:
    minmax(280px, 1fr)
    minmax(300px, 1.15fr)
    minmax(140px, 0.4fr);
}

/* Krok 3: grupowanie | typ wykresu */
.step3 {
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
}

/* --- widok raportu -------------------------------------------------------- */

h4 {
  margin: var(--spacing-lg) 0 var(--spacing-md);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-caps);
  color: var(--text-primary);
}

/* Wykres mieści się w dostępnej szerokości */
.fitted-image {
  display: block;
  margin: 0 auto var(--spacing-lg);
  max-width: 100% !important;
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* Tabela danych statystycznych — przewija się w swoim kontenerze,
   nie rozpychając widoku w poziomie. */
.stats-data-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 var(--spacing-lg) var(--spacing-lg);
  overflow-x: auto;
}

.stats-data {
  width: 100%;
  max-width: 1000px;
  border-collapse: collapse;
  font-size: var(--font-size-sm);
  color: var(--text-primary);
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--panel-radius);
  overflow: hidden;
}

.stats-data thead th {
  padding: var(--spacing-md);
  background: var(--surface-secondary);
  border-bottom: 1px solid var(--border-default);
  color: var(--text-secondary);
  font-weight: var(--font-weight-medium);
  text-align: center;
  white-space: nowrap;
}

.stats-data tbody td,
.stats-data tbody th {
  padding: var(--spacing-sm) var(--spacing-md);
  border-bottom: 1px solid var(--border-subtle);
  font-weight: var(--font-weight-regular);
  text-align: center;
}

.stats-data tbody tr:last-child td,
.stats-data tbody tr:last-child th {
  border-bottom: 0;
}

.stats-data tbody tr:hover {
  background: var(--surface-hover);
}

hr {
  margin: var(--spacing-lg) 0;
  border-color: var(--border-subtle);
}
</style>
